module.exports = __webpack_public_path__ + "8bff03c2be160134ade2a15779c6f109.svg";